// extracted by css-extract-rspack-plugin
export default {"tabContainer":"_46e12714","tabLabel":"_b020e6d5","mobileSeparatorContainer":"_50b03be","mobileSeparator":"_f836f4f9"};